import type { FieldPath, FieldValues } from 'react-hook-form';

export const formFieldFactory =
  <T extends FieldValues>() =>
  <K extends FieldPath<T>>(field: K): K =>
    field;
